const ConsumerType = {
  CommercialIndustrial: "commercial|industrial",
  Private: "private",
  Public: "public",
  TNVS: "tnvs",
};

export default ConsumerType;
